import { getValues } from "@base/util/TypeUtil";
import { SST } from "@biz/definitions/SST";
import { IMotorInfo, motors, RemoteType, SunSailType } from "@biz/definitions/SunSailDefinitions";

export class MotorLogic {
  static getMotorInfo(articleNumber: string | undefined): IMotorInfo | undefined {
    if (!articleNumber)
      return undefined;
    return motors[articleNumber];
  }

  static calcPossibleMotors(sunSailType: SunSailType): IMotorInfo[] {
    if (!MotorLogic.hasMotor(sunSailType))
      return [];
    if (SST.isRaff(sunSailType)) {
      return getValues(motors).filter((item) => item.type === "raff" && !item.deprecated)
    }
    return getValues(motors).filter((item) => item.type === "sunSail" && !item.deprecated)
  }

  static getWirelessMotors(): string[] {
    return getValues(motors).filter((item) => !!item.remoteType && !item.deprecated).map((item) => item.articleNumber);
  }

  static hasMotor(sunSailType: SunSailType): boolean {
    return SST.is(sunSailType, SST.C, SST.CsTwin);
  }

  static getMotorCount(sunSailType: SunSailType): number {
    if (!MotorLogic.hasMotor(sunSailType))
      return 0;
    const granularity = sunSailType === SunSailType.SolidayTwin ? 2 : 1;
    return granularity;
  }

  static getSunWindSensors(type: RemoteType | "all"): {articleNumber: string, disabled?: boolean}[] {
    switch (type) {
      case "all": return [...this.getSunWindSensors("centronic"), ...this.getSunWindSensors("centronic+")];
      case "centronic": return [
        { articleNumber: "71003A004", disabled: true },// "SC811 / standard" Sonnen- und Windsensor Funk mit Stromanschluss
        { articleNumber: "71003A005"}, // "SC861 / solar" Sonnen- und Windsensor Funk mit Solarzelle
        { articleNumber: "00E13001519", disabled: true }, //  "SC911 / rain" Sonnen- und Windsensor Funk mit Solarzelle
      ]
      case "centronic+": return [
        { articleNumber: "00E13001919" }, // "SC811+ / standard": Soliday SO-WI-Sensor SC811 Plus bidirektional mit Stromanschluss
        { articleNumber: "00E13001920"},// "SC911+ / rain" Sonnen-Wind-Regensensor SC911 Plus bidirektional mit Stromanschluss
      ]
    }
    return []
  }
}